import type { NavBGType } from '@/types/layout'

export const darkNavBgRoute = [
  '/security',
  '/de-de/security',
  '/es-es/security',
  '/fr-fr/security',
  '/partners',
  '/de-de/partners',
  '/es-es/partners',
  '/fr-fr/partners',
  '/frameworks',
  '/de-de/frameworks',
  '/es-es/frameworks',
  '/fr-fr/frameworks',
  '/request-demo',
  '/de-de/request-demo',
  '/es-es/request-demo',
  '/fr-fr/request-demo',
  '/features/ai',
  '/de-de/features/ai',
  '/es-es/features/ai',
  '/fr-fr/features/ai',
  '/features/ai-security-compliance',
  '/de-de/features/ai-security-compliance',
  '/es-es/features/ai-security-compliance',
  '/fr-fr/features/ai-security-compliance',
  '/request-demo-follow-up',
  '/de-de/request-demo-follow-up',
  '/es-es/request-demo-follow-up',
  '/fr-fr/request-demo-follow-up',
  '/partner-request-demo-follow-up',
  '/de-de/partner-request-demo-follow-up',
  '/es-es/partner-request-demo-follow-up',
  '/fr-fr/partner-request-demo-follow-up',
  '/rsa-demo',
  '/de-de/rsa-demo',
  '/es-es/rsa-demo',
  '/fr-fr/rsa-demo',
  '/service-partner-signup',
  '/service-partner',
  '/cmmc',
  '/cmmc-compliance-services',
  '/cmmc-2-0',
  '/what-is-cmmc',
  '/cmmc-level-2',
  '/cmmc-enclave',
  '/cmmc-certification',
  '/automated-cloud-provisioning',
  '/expert-support',
  '/automated-documentation',
  '/c3pao-partner-network',
  '/sprs-scoring',
  '/secureframe-virtual-desktops',
  '/secureframe-federal-mdm',
  '/defense-navigator',
  '/assessment-ready-package',
  '/compliance-platform',
  '/request-cmmc-demo',
  '/de-de/request-cmmc-demo',
  '/es-es/request-cmmc-demo',
  '/fr-fr/request-cmmc-demo',
  '/summit',
  '/compliance-resources/contract-requirements-lookup',
  '/compliance-resources/cmmc-readiness-assessment',
]

/** Resolve navbar theme from pathname (used by client Navbar). */
// Marketplace pages that open on the full-bleed ink hero; product and environment pages keep the light nav
const MARKETPLACE_HERO_PAGES =
  /^(?:\/[a-z]{2}-[a-z]{2})?\/marketplace(?:\/(?:microsoft(?:\/category\/[^/]+(?:\/[^/]+)?|\/licensing-guide|\/windows-licensing|\/compare\/gcc-vs-gcc-high)?|fedramp|google-workspace))?\/?$/

export function getNavBgFromPathname(pathname: string): NavBGType {
  if (darkNavBgRoute.includes(pathname)) {
    return 'dark'
  }
  if (pathname.startsWith('/industries')) {
    return 'dark'
  }
  if (MARKETPLACE_HERO_PAGES.test(pathname)) {
    return 'dark'
  }
  return 'light'
}
